/* eslint-disable no-useless-escape */

/* eslint-disable no-eval */
export const emailRegex = RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const inputNumericoEnteros = (evt) => {
  if (
    evt.key === "e" ||
    evt.key === "E" ||
    evt.key === "." ||
    evt.key === "+" ||
    evt.key === "-"
  ) {
    evt.preventDefault();
  }
};

export const nombreFormRegex =
  (message = "Ingrese un nombre válido") =>
  (value) => {
    const isValid = RegExp(/^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\ \-\w\&\.]+$/).test(value);
    if (!isValid) {
      return message;
    }
    return true;
  };

export const validarEquipo = (/** @type {Row} */ row) => {
  if (row?.equipo?.skipValidation) {
    row.equipo.hasError = false;
    row.equipo.errorMessage = null;
    return row;
  }
  row.equipo.hasError = false;
  row.equipo.errorMessage = null;
  if (!row?.equipo?.value) {
    row.equipo.hasError = true;
    row.equipo.errorMessage = "Este campo es obligatorio";
  }
  return row;
};

export const validarSuma = (/** @type {Row} */ row, objValidaton) => {
  if (row?.suma?.skipValidation) {
    row.suma.hasError = false;
    row.suma.errorMessage = null;
    return row;
  }
  row.suma.hasError = false;
  row.suma.errorMessage = null;
  if (!row?.suma?.value) {
    row.suma.hasError = true;
    row.suma.errorMessage = "Este campo es obligatorio";
  }
  const min = objValidaton?.min;
  const max = objValidaton?.max;
  const val = row?.suma?.value;
  if (val < min || val > max) {
    let msgdefault = objValidaton?.msgError
      ? objValidaton?.msgError
      : `El valor ingresado debe ser entre $${objValidaton?.min} y $${objValidaton?.max}`;
    row.suma.hasError = true;
    row.suma.errorMessage = msgdefault;
  }
  return row;
};
